import React,{Component} from 'react';
import {createMarkup} from './Factory';

class NewsDetailsContainer extends Component {
	
	render(){				
		const { title,content,date,image_data} = this.props;
		let {image:imgUrl,title:image_title,alt} = image_data;
		let divStyle = {
				backgroundImage: 'url(' + imgUrl + ')',
				backgroundSize: 'cover',
				maxWidth: '100%',
		}	
		return(
				<article className="col-md-8 article-full">
					 <h1 dangerouslySetInnerHTML={createMarkup(title.rendered)}></h1>
					 <div className="times">
						<time dateTime={date}>{date}</time>
					 </div>
					 <div className="fixed-ht-img" style={divStyle}>
						<img src={imgUrl} alt={alt} title={image_title} />
					 </div>
					 <div className="md-txt article-txt content-section" dangerouslySetInnerHTML={createMarkup(content.rendered)}></div>
				</article>
		)
	}
}
export default NewsDetailsContainer;


// WEBPACK FOOTER //
// ./src/components/NewsDetails.js